var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[_c('h1',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.$t('view.component.contacts.list.header')))]),_c('div',{staticClass:"list-wrapper"},[_c('ContactsList'),_c('div',{staticClass:"boxes"},[_c('ContactsFormAdd'),_c('ContactsAdv')],1)],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }